import cx from "classnames";
import React from "react";
import { CardResult } from "@/appInterface/windows/VoteWindow/VoteResults/CardResult";
import type { getSortedChildren } from "@/appInterface/windows/VoteWindow/VoteResults/helpers";
import { ImageResult } from "@/appInterface/windows/VoteWindow/VoteResults/ImageResult";
import { ShapeResult } from "@/appInterface/windows/VoteWindow/VoteResults/ShapeResult";
import { StickerResult } from "@/appInterface/windows/VoteWindow/VoteResults/StickerResult";
import { TextResult } from "@/appInterface/windows/VoteWindow/VoteResults/TextResult";
import type { WidgetData } from "@/appInterface/windows/VoteWindow/VoteResults/types";
import style from "@/appInterface/windows/VoteWindow/VoteResults/voteResults.module.css";

type CandidateItemProps = {
    res: ReturnType<typeof getSortedChildren>[number];
    percent: number;
    selected: boolean;
    onSelect: (UID: string) => void;
};

type RenderResultByEntityTypeProps = {
    widgetData: WidgetData;
};

function RenderResultByEntityType({ widgetData }: RenderResultByEntityTypeProps) {
    switch (widgetData.entityType) {
        case "media": {
            return <ImageResult widgetData={widgetData} />;
        }
        case "shape": {
            return <ShapeResult widgetData={widgetData} />;
        }
        case "text": {
            return <TextResult widgetData={widgetData} />;
        }
        case "sticker": {
            return <StickerResult widgetData={widgetData} />;
        }
        case "card": {
            return <CardResult widgetData={widgetData} />;
        }
        default: {
            return <div>Unknown</div>;
        }
    }
}

export const CandidateItem = React.memo(function CandidateItem({
    res,
    percent,
    selected,
    onSelect,
}: CandidateItemProps) {
    return (
        <div
            className={cx(style.candidateItemWrapper, { [style.selected]: selected })}
            onClick={() => onSelect(res.widgetData.UID)}
        >
            <div className={style.candidateItemView}>
                <RenderResultByEntityType widgetData={res.widgetData} />
            </div>
            <div className={style.candidateItemResultWrapper}>
                <div className={style.candidateItemResultVoteCount}>{res.votes.length}</div>
                <div className={style.candidateItemResultPercent}>{`(${percent} %)`}</div>
            </div>
            <div className={style.candidateItemResultScale}>
                <div
                    className={style.candidateItemResultScaleProgress}
                    style={{ width: `${percent}%` }}
                />
            </div>
        </div>
    );
});
